export default __webpack_public_path__ + "static/media/peso.1fc2dfb0.svg";